import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register as registerSwiper } from 'swiper/element/bundle';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    registerSwiper();
  })
  .catch((err) => console.error(err));
